import {
    POPULATE_BASKET,
    POPULATE_BASKET_ERROR,
    POPULATE_BASKET_SUCCESS,
} from "core-web/state/models/Basket/constants";

import PopulateBasket from "core-web/libs/GrebbCommerceAPI/Basket/PopulateBasket";
import { acquireMutex } from "core-web/state";
import buildCheckoutResponse from "core-web/utils/buildCheckoutResponse";
import getBasketId from "core-web/state/models/Basket/utils/getBasketId";
import store from "core-web/state/store";

export const populateBasket = (partNos) => async (dispatch) => {
    const basketId = (await getBasketId()) ?? null;
    const mutexLock = await acquireMutex("basket.getBasket");
    dispatch({ type: POPULATE_BASKET });
    try {
        if (!Array.isArray(partNos)) {
            throw new Error("'partNos' is not an array.");
        }

        const { response, status } = await PopulateBasket(partNos, basketId);

        if (status === 404) {
            dispatch({ type: POPULATE_BASKET_ERROR });
            return;
        }

        const { checkoutResponse } = buildCheckoutResponse(response);

        dispatch(Object.assign({ type: POPULATE_BASKET_SUCCESS, basketId }, checkoutResponse));
        mutexLock();

        return response;
    } catch (e) {
        dispatch({ type: POPULATE_BASKET_ERROR });
        console.log(e);
        mutexLock();

        return null;
    }
};

export default (partNos) => store.dispatch(populateBasket(partNos));
